import { useAuth } from './AuthContext'
import { useBrandColors } from './ThemeContext'
import { hexToRgba } from './theme'
import { legibleOn, contrast, textOn } from './contrast'

// ─── Palette DARK ─────────────────────────────────────────────────────
const dark = {
  bg:              '#0D0D0D',
  bgCard:          '#161616',
  bgCard2:         '#1E1E1E',
  bgCard3:         '#1E1E1E',
  bgHover:         'rgba(255, 255, 255, 0.04)',
  border:          'rgba(255, 255, 255, 0.07)',
  borderLight:     'rgba(255, 255, 255, 0.12)',
  text:            '#F0EAE8',
  textMuted:       'rgba(240, 234, 232, 0.55)',
  textDim:         'rgba(240, 234, 232, 0.3)',
  navBg:           'rgba(13, 13, 13, 0.97)',
  navIconInactive: 'rgba(240, 234, 232, 0.35)',
  inputBg:         '#1E1E1E',
  cronoBg:         'rgba(0, 0, 0, 0.55)',
  dotInactive:     'rgba(255, 255, 255, 0.2)',
}

// ─── Palette LIGHT ────────────────────────────────────────────────────
const light = {
  bg:              '#F7F2F4',
  bgCard:          '#FFFFFF',
  bgCard2:         '#F0EBED',
  bgCard3:         '#E8E3E5',
  bgHover:         'rgba(232, 57, 125, 0.05)',
  border:          'rgba(232, 57, 125, 0.12)',
  borderLight:     'rgba(232, 57, 125, 0.2)',
  text:            '#1A0810',
  textMuted:       'rgba(26, 8, 16, 0.5)',
  textDim:         'rgba(26, 8, 16, 0.3)',
  navBg:           'rgba(255, 255, 255, 0.97)',
  navIconInactive: 'rgba(26, 8, 16, 0.35)',
  inputBg:         '#F0EBED',
  cronoBg:         'rgba(232, 57, 125, 0.06)',
  dotInactive:     'rgba(232, 57, 125, 0.25)',
}

// ─── Colori fissi brand-aware ─────────────────────────────────────────
function makeFixed(brandColors, palette) {
  // Testo/icone nel colore del brand: devono leggersi su tutte le carte del tema (anche la piu' difficile).
  // Col rosa del Giro non cambia niente; un brand chiaro (il giallo del Tour) diventa un oro scuro in tema chiaro.
  let rosaText = brandColors.rosa
  for (const bg of [palette.bg, palette.bgCard, palette.bgCard2, palette.bgCard3]) rosaText = legibleOn(rosaText, bg, 3)
  // Testo sopra il brand: quello del DB, a meno che sia illeggibile (nuove competizioni).
  const brandText = contrast(brandColors.brandText, brandColors.rosa) >= 3 ? brandColors.brandText : textOn(brandColors.rosa)
  return {
    rosa:          brandColors.rosa,
    rosaText,
    rosaLight:     brandColors.rosaLight,
    rosaDark:      brandColors.rosaDark,
    brandText,
    rosaSubtle:    brandColors.rosaSubtle,
    rosaBorder:    brandColors.rosaBorder,
    rosaGlow:      brandColors.rosaGlow,
    error:         brandColors.rosa,
    errorBg:       brandColors.errorBg,
    navBorder:     hexToRgba(brandColors.rosa, 0.15),
    // Feedback non-brand
    success:       '#10B981',
    successBg:     'rgba(16,185,129,0.1)',
    successBorder: 'rgba(16,185,129,0.3)',
    warning:       '#F59E0B',
    warningBg:     'rgba(234,179,8,0.08)',
    warningBorder: 'rgba(234,179,8,0.25)',
    info:          '#7cb9ff',
    infoBg:        'rgba(59,130,246,0.1)',
    infoBorder:    'rgba(59,130,246,0.3)',
    flip:          '#6366f1',
    flipBg:        'rgba(99,102,241,0.08)',
    flipBorder:    'rgba(99,102,241,0.25)',
  }
}

export function useThemeColors() {
  const { theme } = useAuth()
  const { brandColors } = useBrandColors()
  const palette = theme === 'light' ? light : dark
  return { ...palette, ...makeFixed(brandColors, palette) }
}

export function getThemeColors(theme, brandColors) {
  const palette = theme === 'light' ? light : dark
  const { makeColors } = require('./theme')
  const bc = brandColors ?? makeColors()
  return { ...palette, ...makeFixed(bc, palette) }
}

export { dark, light }